import React from 'react';
import styles from './welcome.module.css';
import { useSelector } from 'react-redux';
import BtnLogin from '../auth/login/BtnLogin';
import { useNavigate } from 'react-router-dom';
import Navbar from '../layouts/layoutMain/Navbar';
import { useGetUserProfile } from '../../hooks/api/useUserProfile';

const WelcomePage = () => {
    const { data, status } = useGetUserProfile();
    const { nameOrganization, logoOrganization } = useSelector(
        state => state.auth
    );
    const navigation = useNavigate();

    if (status === 'success') {
        if (data.completedProfile) {
            return navigation('/');
        }
    }

    const goToProfile = () => {
        navigation('/');
    };

    return (
        <>
            <Navbar />
            <div className="loginLayout__container">
                <div className={styles.login__container}>
                    <div className={styles.contenLogo}>
                        <div className={styles.logo}>
                            <img
                                src={logoOrganization}
                                alt={nameOrganization}
                            />
                            <p className={styles.info_organization_welcome}>
                                Welcome!
                            </p>
                        </div>
                        <div>
                            <h1 className={styles.info_organization_name}>
                                {nameOrganization}
                            </h1>
                        </div>
                    </div>
                    <div className={styles.login__body}>
                        <div className={styles.login__text}>
                            <div>
                                <p className={styles.font_size_normal_info}>
                                    Join the campfire and conversation by
                                    setting up your profile.
                                </p>
                            </div>
                        </div>
                        <BtnLogin action={goToProfile}>Create Profile</BtnLogin>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WelcomePage;
